import React from 'react';
import { Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

// Sadrzaj po nivou (deal/super/premium) - 'logo' vazi za CEO nivo (isti za confirmed/canceled).
// Premium nema Odustani (poslovno pravilo), pa nema ni "canceled" ishod za njega. Naslov/tekst
// (jokerConfirmed*/jokerCanceled* kljucevi u loyalty.json) su ISTI za sve nivoe po istom ishodu,
// racunaju se u komponenti (ispod) preko t() - ne zive ovde jer ovaj niz je van komponente.
// hasCircleBg - beli krug ISCRTAN u CSS-u iza slike (SAMO Super "confirmed" - ta slika nema svoj
// baked-in "sjaj"). Premium/Deal slike vec imaju svoj izgled bez potrebe za ovim.
const JOKER_RESULT_CONTENT = {
    deal: {
        logo: 'joker-purple-logo-full.png',
        confirmed: { image: 'loyalty-deal-joker-confirmed.png', hasCircleBg: false },
        canceled: { image: 'loyalty-deal-joker-canceled.png', hasCircleBg: false },
    },
    super: {
        logo: 'joker-purple-logo.png',
        confirmed: { image: 'loyalty-super-joker-confirmed.png', hasCircleBg: true },
        canceled: { image: 'loyalty-super-joker-canceled.png', hasCircleBg: false },
    },
    premium: {
        logo: 'joker-gold-logo.png',
        confirmed: { image: 'loyalty-premium-joker-confirmed.png', hasCircleBg: false },
    },
};

// tier dolazi kao 'Deal'/'Super'/'Premium' (TIER_NAMES iz LoyaltySpecialConditionGroup.js) -
// normalizuje se ovde, poziocima ne treba da vode racuna o velicini slova.
const LoyaltyJokerResultModal = ({ show, onClose, tier, variant }) => {
    const { t } = useTranslation('loyalty');
    const tierKey = tier ? tier.toLowerCase() : null;
    const tierContent = tierKey ? JOKER_RESULT_CONTENT[tierKey] : null;
    const variantMeta = tierContent && variant ? tierContent[variant] : null;

    if (!variantMeta) {
        return null;
    }

    const isConfirmed = variant === 'confirmed';

    return (
        <Modal
            show={show}
            onHide={onClose}
            centered
            dialogClassName="joker-result-modal-dialog"
            contentClassName="joker-result-modal-shell"
        >
            {/* Pozadina (boja/gradijent) i boja teksta se razlikuju po nivou - vidi
                .joker-result-modal-content-${tierKey} u Loyalty.css. */}
            <div className={`joker-result-modal-content joker-result-modal-content-${tierKey}`}>
                <button type="button" className="joker-result-modal-close" onClick={onClose} aria-label={t('zatvori')}>
                    <i className="far fa-times-circle"></i>
                </button>
                <img
                    src={`${process.env.PUBLIC_URL}/images/loyalty/joker/${tierContent.logo}`}
                    alt=""
                    className="joker-result-modal-logo"
                />
                <div className="joker-result-modal-text">
                    <h3 className="joker-result-modal-title">
                        {isConfirmed ? t('jokerConfirmedTitle') : t('jokerCanceledTitle')}
                    </h3>
                    {isConfirmed ? (
                        <>
                            <p className="joker-result-modal-body">{t('jokerConfirmedBody1')}</p>
                            <p className="joker-result-modal-body">{t('jokerConfirmedBody2')}</p>
                        </>
                    ) : (
                        <p className="joker-result-modal-body">{t('jokerCanceledBody')}</p>
                    )}
                </div>
                <div className="joker-result-modal-media">
                    {variantMeta.hasCircleBg && <div className="joker-result-modal-media-circle"></div>}
                    <img
                        src={`${process.env.PUBLIC_URL}/images/loyalty/joker/${variantMeta.image}`}
                        alt=""
                        className="joker-result-modal-image"
                    />
                </div>
            </div>
        </Modal>
    );
};

export default LoyaltyJokerResultModal;
